export default "__VITE_ASSET__Bm$Nn3sj__"